import { zergApi } from "@/service/zerg";

class SettingTiposAcuerdosService {

    async createOrUpdate(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/tipos-acuerdos/create-or-update', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    
    async list(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/tipos-acuerdos/list', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async delete(params) {
        try {
            const { data } = await zergApi.post('setting/payroll/tipos-acuerdos/delete', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new SettingTiposAcuerdosService();
